import React, { useRef, useState } from 'react';
import { Play, Send, MessageCircle, CheckCircle2 } from 'lucide-react';
import Reveal from './Reveal';
import { WA_URL } from '../lib/utils';

const VIDEO_SRC = '/videos/hm-talent-contrate-conosco.mp4';
const POSTER_SRC = '/videos/hm-talent-contrate-conosco-poster.jpg';

const POINTS = [
  'Divulgação estratégica da vaga e hunting ativo',
  'Triagem técnica e entrevistas comportamentais',
  'Shortlist com parecer detalhado em até 72h',
  'Garantia contratual de reposição',
];

const STATS = [
  ['+200', 'empresas atendidas'],
  ['+3.000', 'contratações'],
  ['95%', 'de assertividade'],
];

const VerticalVideo = () => {
  const ref = useRef(null);
  const [started, setStarted] = useState(false);
  return (
    <div className="relative mx-auto w-full max-w-[290px] sm:max-w-[330px]">
      <div className="absolute -inset-6 rounded-[3rem] hm-gradient opacity-25 blur-2xl" aria-hidden="true" />
      <div className="relative aspect-[9/16] rounded-[2rem] overflow-hidden border-[6px] border-white card-shadow bg-slate-900">
        <video
          ref={ref}
          data-testid="empresas-video"
          src={VIDEO_SRC}
          poster={POSTER_SRC}
          className="w-full h-full object-cover"
          playsInline
          preload="metadata"
          controls={started}
          onPlay={() => setStarted(true)}
        />
        {!started && (
          <button
            type="button"
            onClick={() => ref.current?.play()}
            data-testid="empresas-video-play-btn"
            aria-label="Assistir ao vídeo da HM Talent"
            className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-slate-900/25 hover:bg-slate-900/10 transition-colors group"
          >
            <span className="w-20 h-20 rounded-full hm-gradient flex items-center justify-center shadow-2xl ring-8 ring-white/30 group-hover:scale-110 transition-transform">
              <Play className="w-9 h-9 text-white ml-1" fill="currentColor" />
            </span>
            <span className="text-white text-sm font-bold bg-slate-900/50 backdrop-blur-sm px-3 py-1 rounded-full">Assista • 1 min</span>
          </button>
        )}
      </div>
    </div>
  );
};

export const ContrateConoscoVideo = () => (
  <section className="section-padding bg-hm-yellow relative overflow-hidden" data-testid="empresas-video-section">
    <div className="container-hm grid lg:grid-cols-2 gap-x-16 gap-y-10 items-center">
      <Reveal variant="slideRight" className="lg:col-start-1 lg:row-start-1 lg:self-end">
        <p className="text-xs uppercase tracking-widest text-hm-orange font-bold mb-3">Contrate conosco</p>
        <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 leading-tight" data-testid="empresas-video-title">
          Pare de perder tempo com contratações. Deixe com a HM Talent.
        </h2>
        <p className="mt-4 text-slate-700 leading-relaxed">
          Triar currículos, agendar entrevistas e avaliar candidatos tira o foco da sua equipe e atrasa a operação.
          A HM Talent assume o processo seletivo de ponta a ponta — da divulgação da vaga à entrega dos profissionais
          mais aderentes à sua empresa — com agilidade, método e garantia.
        </p>
      </Reveal>

      <Reveal variant="scale" className="lg:col-start-2 lg:row-start-1 lg:row-span-2">
        <VerticalVideo />
      </Reveal>

      <Reveal variant="slideRight" delay={120} className="lg:col-start-1 lg:row-start-2 lg:self-start">
        <ul className="space-y-2.5">
          {POINTS.map((t) => (
            <li key={t} className="flex items-start gap-2 text-slate-700">
              <CheckCircle2 className="w-5 h-5 text-hm-orange shrink-0 mt-0.5" /> {t}
            </li>
          ))}
        </ul>
        <div className="mt-7 grid grid-cols-3 gap-3">
          {STATS.map(([n, l]) => (
            <div key={l} className="bg-white rounded-2xl border border-orange-100 px-3 py-4 text-center card-shadow">
              <div className="text-2xl md:text-3xl font-extrabold text-hm-orange">{n}</div>
              <div className="text-xs text-slate-600 mt-1 font-semibold">{l}</div>
            </div>
          ))}
        </div>
        <div className="mt-8 flex flex-col sm:flex-row gap-4">
          <a href="#solicitar-proposta" className="btn-hm" data-testid="empresas-video-proposal-btn">
            <Send className="w-5 h-5" /> Solicitar proposta
          </a>
          <a
            href={WA_URL('Olá! Assisti ao vídeo no site e quero contratar com a HM Talent.')}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-hm-outline"
            data-testid="empresas-video-whatsapp-btn"
          >
            <MessageCircle className="w-5 h-5" /> Falar no WhatsApp
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
